var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('div',[_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.deviceData, null, "\t")))])]):_c('div',{staticClass:"pb-2 text-center"},[_c('b-spinner',{attrs:{"label":"Spinning","variant":"primary"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }